import React from 'react';


export default function FirstStepLayout({
  input, btn, text, isCompact
}) {
  if (isCompact) {
    return (
      <div>
        <div className="flex-row-center">
          {input}
          {React.cloneElement(btn, {
            className: "btn-brand p-y-0_5 p-x-1 m-l-1 text-nowrap"
          })}
        </div>
        {text}
      </div>
    );
  }
  return (
    <div className="m-t-1_5">
      {input}
      {text}
      {React.cloneElement(btn, {
        className: "btn-brand block f-s-1 w-100"
      })}
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/RegistrationPopup/elements/FirstStepLayout.jsx
 **/